<ng-container *ngIf="parentForm" [formGroup]="parentForm">
  <ng-container formArrayName="answer">
    <ng-container [formGroupName]="0">
      <ng-container formGroupName="valueCoding">
        <div class="d-flex flex-row">
            <div [ngClass]="{ 'form-check form-check-inline': true, 'criterion--inclusion': inclusion, 'criterion--exclusion': !inclusion }">
              <label>
                <input formControlName="code" class="form-check-input" type="radio" value="met">
                <img class="yes-selection" src="/assets/svg/criterion/unselected/yes-unselected.svg" alt="Yes"/>
              </label>
            </div>
            <div [ngClass]="{ 'form-check form-check-inline': true, 'criterion--inclusion': inclusion, 'criterion--exclusion': !inclusion }">
              <label>
                <input formControlName="code" class="form-check-input" type="radio" value="unknown">
                <img class="unknown-selection" src="/assets/svg/criterion/unknown/unknown-unselected.svg" alt="Unknown"/>
              </label>
            </div>
            <div [ngClass]="{ 'form-check form-check-inline': true, 'criterion--inclusion': inclusion, 'criterion--exclusion': !inclusion }">
              <label>
                <input formControlName="code" class="form-check-input" type="radio" value="not-met">
                <img class="no-selection" src="/assets/svg/criterion/unselected/no-unselected.svg" alt="No"/>
              </label>
            </div>
          <span [ngClass]="{ 'ineligible' : ineligible }">{{ label }}</span>
        </div>
        <input type="hidden" formControlName="system">
        <input type="hidden" formControlName="display">
      </ng-container>
    </ng-container>
  </ng-container>
  <input type="hidden" formControlName="linkId">
</ng-container>
